import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function LoadingIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8 2v2.4m0 7.2V14M4.4 8H2m12 0h-2.4m.647 4.247L10.55 10.55m1.697-6.75L10.55 5.497m-6.797 6.75L5.45 10.55M3.753 3.8 5.45 5.497" /></svg>
  );
}

export default LoadingIcon;
